const RAPTS_API_BASE_URL = 'https://rapts.tech:8000';
const ANALYTIC_API_BASE_URL = 'https://analytic.rapts.ru:8000';

function resolveApiBaseUrl(): string {
  if (process.env.REACT_APP_API_BASE_URL) {
    return process.env.REACT_APP_API_BASE_URL;
  }
  if (typeof window !== 'undefined' && window.location.hostname === 'analytic.rapts.ru') {
    return ANALYTIC_API_BASE_URL;
  }
  return RAPTS_API_BASE_URL;
}

// Конфигурация API
export const API_CONFIG = {
  // Базовый URL для API - используем порт 8000
  BASE_URL: resolveApiBaseUrl(),

  // Полные URL'ы для различных эндпоинтов
  AUTH: {
    TOKEN: '/accounts/api/token/',
    REFRESH: '/accounts/api/token/refresh/',
    VERIFY_CODE: '/accounts/api/token/verify-code/',
    PROFILE: '/accounts/api/profile/',
  },

  API_V1: {
    LAB_EXAMS: '/api/v1/lab-exams/create/',
    LAB_EXAMS_LIST: '/api/v1/lab-exams/',
    DATE: '/api/v1/lab-exam-date',
    COMPANY_CREATE: '/api/v1/companies/create/',
    CERTIFICATES: '/api/v1/certificates/',
    CERTIFICATES_COUNT: '/api/v1/certificates/count/',
    DECLARATIONS: '/api/v1/declarations/',
    DECLARATIONS_COUNT: '/api/v1/declarations/count/',
    VOLUNTARY_CERTIFICATES: '/api/v1/voluntary-certificates/',
    VOLUNTARY_CERTIFICATES_CREATE: '/api/v1/voluntary-certificates/create/',
    VOLUNTARY_CERTIFICATES_OS: '/api/v1/voluntary-certificates/os/',
    VOLUNTARY_CERTIFICATES_OS_CREATE: '/api/v1/voluntary-certificates/os/create/',
    VOLUNTARY_CERTIFICATES_LABORATORY: '/api/v1/voluntary-certificates/laboratory/',
    VOLUNTARY_CERTIFICATES_LABORATORY_CREATE: '/api/v1/voluntary-certificates/laboratory/create/',
    VOLUNTARY_CERTIFICATES_MANUFACTURE: '/api/v1/voluntary-certificates/manufacture/',
    VOLUNTARY_CERTIFICATES_MANUFACTURE_CREATE: '/api/v1/voluntary-certificates/manufacture/create/',
    VOLUNTARY_CERTIFICATE_ITEM: '/api/v1/voluntary-certificates/', // + {id}/
    LETTERS_GRAPH: '/api/v1/analytics/letters/',
    LETTERS_COUNT: '/api/v1/analytics/letters/count/',
    BITRIX_DEALS: '/api/v1/bitrix-deals/',
    COMPANIES: '/api/v1/companies/',
    REGIONS: '/api/v1/regions/',
    CERTIFICATION_BODY: '/api/v1/certification_body/',
    TESTING_LABORATORY: '/api/v1/testing_laboratory/',
    MATERIALS: {
      PE: '/api/v1/materials/pe/',
      PPR: '/api/v1/materials/ppr/',
      PVH: '/api/v1/materials/pvh/',
    },
    MATERIAL_MANUFACTURE: {
      PE: '/api/v1/materials/manufacture/pe/',
      PPR: '/api/v1/materials/manufacture/ppr/',
      PVH: '/api/v1/materials/manufacture/pvh/',
    },
  },

  LEGACY: {
    COMPANY_CREATE: '/api/v1/company-create/',
  },
};

// Функция для получения полного URL
export const getApiUrl = (endpoint: string): string => {
  return `${API_CONFIG.BASE_URL}${endpoint}`;
};

// Функция для получения URL аутентификации
export const getAuthUrl = (endpoint: keyof typeof API_CONFIG.AUTH): string => {
  return getApiUrl(API_CONFIG.AUTH[endpoint]);
};

// Функция для получения URL API v1
export const getApiV1Url = (endpoint: string): string => {
  const value = API_CONFIG.API_V1[endpoint as keyof typeof API_CONFIG.API_V1];
  if (typeof value === 'string') {
    return getApiUrl(value);
  }
  return getApiUrl(endpoint);
};

// Функция для получения URL материалов
export const getMaterialUrl = (materialType: string, endpoint: string = ''): string => {
  const baseUrl = API_CONFIG.API_V1.MATERIALS[materialType.toUpperCase() as keyof typeof API_CONFIG.API_V1.MATERIALS];
  if (!baseUrl) {
    throw new Error(`Неизвестный тип материала: ${materialType}`);
  }
  return getApiUrl(baseUrl + endpoint);
};

export const getVoluntaryCertificateItemUrl = (id: number | string): string => {
  return getApiUrl(`${API_CONFIG.API_V1.VOLUNTARY_CERTIFICATE_ITEM}${id}/`);
};

export const getMaterialManufactureUrl = (materialType: string, endpoint: string = ''): string => {
  const upperType = materialType.toUpperCase() as keyof typeof API_CONFIG.API_V1.MATERIAL_MANUFACTURE;
  const baseUrl = API_CONFIG.API_V1.MATERIAL_MANUFACTURE[upperType];
  if (!baseUrl) {
    throw new Error(`Неизвестный тип материала для производителей: ${materialType}`);
  }
  return getApiUrl(baseUrl + endpoint);
};

